/* eslint-disable max-lines */
/* eslint-disable prefer-object-spread */
import axios from 'axios';
import SparkMD5 from 'spark-md5';
import { SALES } from '../constants';

export const uploadDocument = async (
  fileFormat,
  fileName,
  fileType,
  formData,
  accessToken,
  setStatementUploadProgress,
  setStatementLinearProgress
) => {
  let response = null;
  try {
    response = await axios.post(
      `${process.env.REACT_APP_DOCUMENT_UPLOAD_URL}?format=${fileFormat}&name=${fileName}&type=${fileType}`,
      formData,
      {
        headers: {
          appid: 'sales',
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${accessToken}`,
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setStatementUploadProgress((prev) => ({ ...prev, [fileType]: percentCompleted }));

          if (percentCompleted === 100) {
            setStatementLinearProgress((prev) => ({ ...prev, [fileType]: true }));
          }
        },
      }
    );
  } catch (e) {
    return response;
  }
  return response;
};

export const uploadDocumentXL = async (
  fileFormat,
  fileName,
  fileType,
  fileSize,
  fileMd5Base64,
  accessToken,
  setStatementUploadProgress,
  setStatementLinearProgress
) => {
  let response = null;
  const requestBody = {
    format: fileFormat,
    name: fileName,
    type: fileType,
    size: fileSize,
    contentMD5: fileMd5Base64,
  };
  try {
    response = await axios.post(`${process.env.REACT_APP_DOCUMENT_UPLOAD_XL_URL}`, requestBody, {
      headers: {
        appid: 'sales',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },

      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setStatementUploadProgress((prev) => ({ ...prev, [fileType]: percentCompleted }));

        if (percentCompleted === 100) {
          setStatementLinearProgress((prev) => ({ ...prev, [fileType]: true }));
        }
      },
    });
  } catch (e) {
    return response;
  }
  return response;
};

export const uploadDocumentByPreSignedURL = async (
  preSignedUrl,
  file,
  fileMd5Base64,
  setStatementUploadProgress,
  setStatementLinearProgress,
  fileType
) => {
  let response = null;
  try {
    response = await axios.put(preSignedUrl, file, {
      headers: {
        appid: 'sales',
        'Content-Type': 'multipart/form-data',
        'Content-MD5': fileMd5Base64,
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setStatementUploadProgress((prev) => ({ ...prev, [fileType]: percentCompleted }));

        if (percentCompleted === 100) {
          setStatementLinearProgress((prev) => ({ ...prev, [fileType]: true }));
        }
      },
    });
  } catch (e) {
    return response;
  }
  return response;
};

const handleCancelUpload = (typeName, context, cancelData) => {
  if (typeName === 'act') {
    context.setCancelActupload(cancelData);
  }
  if (typeName === 'atm') {
    context.setCancelAtmupload(cancelData);
  }
  if (typeName === 'businessOwnerAddress') {
    context.setCancelBOAupload(cancelData);
  }
};
export const uploadDocChecklist = async (...args) => {
  const fileFormat = args[0];
  const fileName = args[1];
  const fileType = args[2];
  const formData = args[3];
  const accessToken = args[4];
  const typeName = args[5];
  const setProgress = args[6];
  const context = args[7];
  let response = null;
  const source = axios.CancelToken.source();
  const cancelToken = source.token;
  const cancelData = {
    source,
    typeName,
  };
  if (typeName === 'deedOfTrust') {
    context.setCancelDeed(cancelData);
  }
  if (typeName === 'articleIncorp') {
    context.setCancelArtIncorp(cancelData);
  }
  if (typeName === 'certIncorp') {
    context.setCancelCertIncorp(cancelData);
  }
  if (typeName === 'regCertificate') {
    context.setCancelRegCer(cancelData);
  }
  if (typeName === 'corpResolution') {
    context.setCancelCorpRes(cancelData);
  }
  if (typeName === 'listOfOfficers') {
    context.setCancelListOff(cancelData);
  }
  if (typeName === 'dbaResolution') {
    context.setCancelDbaRes(cancelData);
  }
  if (typeName === 'LlcResolution') {
    context.setCancelLlcRes(cancelData);
  }
  if (typeName === 'opAgreement') {
    context.setCancelOpAgree(cancelData);
  }
  if (typeName === 'certOfOrg') {
    context.setCancelCertOrg(cancelData);
  }
  if (typeName === 'certOfTrustReg') {
    context.setCancelTrustReg(cancelData);
  }
  if (typeName === 'businessAddress') {
    context.setCancelBAupload(cancelData);
  }
  if (typeName === 'certOfIncumbency') {
    context.setCancelIncumbency(cancelData);
  }
  if (typeName === 'act22') {
    context.setCancelAct22upload(cancelData);
  }
  handleCancelUpload(typeName, context, cancelData);
  try {
    response = await axios.post(
      `${process.env.REACT_APP_DOCUMENT_UPLOAD_URL}?format=${fileFormat}&name=${fileName}&type=${fileType}`,
      formData,
      {
        cancelToken,
        headers: {
          appid: 'sales',
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${accessToken}`,
        },
        onUploadProgress: (ProgressEvent) => {
          const percentageCompleted = Math.round(
            (ProgressEvent.loaded * 100) / ProgressEvent.total
          );
          // controller.abort()
          setProgress((prevState) =>
            Object.assign({}, prevState, { [typeName]: percentageCompleted })
          );
        },
      }
    );
  } catch (e) {
    return response;
  }
  return response;
};
export const uploadDocXLDocCheckilst = async (...args) => {
  const fileFormat = args[0];
  const fileName = args[1];
  const fileType = args[2];
  const fileSize = args[3];
  const fileMd5Base64 = args[4];
  const accessToken = args[5];
  const typeName = args[6];
  const setProgress = args[7];
  const context = args[8];
  let response = null;
  const requestBody = {
    format: fileFormat,
    name: fileName,
    type: fileType,
    size: fileSize,
    contentMD5: fileMd5Base64,
  };
  const source = axios.CancelToken.source();
  const cancelToken = source.token;
  const cancelData = {
    source,
    typeName,
  };

  if (typeName === 'deedOfTrust') {
    context.setCancelDeed(cancelData);
  }
  if (typeName === 'corpResolution') {
    context.setCancelCorpRes(cancelData);
  }
  if (typeName === 'certIncorp') {
    context.setCancelCertIncorp(cancelData);
  }
  if (typeName === 'articleIncorp') {
    context.setCancelArtIncorp(cancelData);
  }
  if (typeName === 'listOfOfficers') {
    context.setCancelListOff(cancelData);
  }
  if (typeName === 'regCertificate') {
    context.setCancelRegCer(cancelData);
  }
  if (typeName === 'dbaResolution') {
    context.setCancelDbaRes(cancelData);
  }
  if (typeName === 'LlcResolution') {
    context.setCancelLlcRes(cancelData);
  }
  if (typeName === 'certOfOrg') {
    context.setCancelCertOrg(cancelData);
  }
  if (typeName === 'opAgreement') {
    context.setCancelOpAgree(cancelData);
  }
  if (typeName === 'certOfTrustReg') {
    context.setCancelTrustReg(cancelData);
  }
  if (typeName === 'certOfIncumbency') {
    context.setCancelIncumbency(cancelData);
  }
  if (typeName === 'businessAddress') {
    context.setCancelBAupload(cancelData);
  }
  if (typeName === 'act22') {
    context.setCancelAct22upload(cancelData);
  }
  handleCancelUpload(typeName, context, cancelData);
  try {
    response = await axios.post(`${process.env.REACT_APP_DOCUMENT_UPLOAD_XL_URL}`, requestBody, {
      cancelToken,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
        appid: SALES,
      },
      onUploadProgress: (progEvent) => {
        const percentageCompleted = Math.round((progEvent.loaded * 100) / progEvent.total);
        setProgress((prev) => Object.assign({}, prev, { [typeName]: percentageCompleted }));
      },
    });
  } catch (e) {
    return response;
  }
  return response;
};

export const saveDocChecklist = async (docIds, context, flagCheck) => {
  const {
    accessToken,
    language,
    location,
    businessContactInformation,
    applicationId,
    applicantId,
  } = context;
  const formData = {
    Event: 'CaptureDocumentChecklist',
    Application: {
      ApplicationID: applicationId || null,
      ApplicantID: applicantId || null,
      TemplateVersion: '2021-11-24',
      Source: {
        Language: language,
        Location: location === 'VI' ? 'VI' : 'PR',
        UtmSource: null,
        UtmMedium: null,
        UtmCampaign: null,
        UtmContent: null,
        UtmTerm: null,
        BranchCode: null,
      },
      Business: {
        DocReUploadFlag: flagCheck,
        Type: businessContactInformation.businessType,
        ...(returnBusinessDocs(businessContactInformation.businessType, docIds).length > 0
          ? {
              BusinessDocuments: returnBusinessDocs(
                businessContactInformation.businessType,
                docIds
              ),
            }
          : {}),
      },
      Processing: {
        CaseReference: [],
      },
    },
  };
  let result = null;
  try {
    result = await axios.post(process.env.REACT_APP_SAVE_SUBMIT_APPLICATION_URL, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        appid: SALES,
        'Content-Type': 'application/json; charset=UTF-8',
      },
    });
  } catch (error) {
    return error.response;
  }
  return result;
};

const typeDBACheck = (selectedType, docIds) => {
  if (selectedType === 'DBA') {
    return [
      ...(docIds.dbaResolution
        ? [
            {
              DocType: 'DBA Resolution',
              DocId: docIds.dbaResolution,
            },
          ]
        : []),
      ...(docIds.regCertificate
        ? [
            {
              DocType: 'Commercial Registration Certificate',
              DocId: docIds.regCertificate,
            },
          ]
        : []),
    ];
  }
};
const typeCorporationPartnership = (selectedType, docIds) => {
  if (
    selectedType === 'Corporation' ||
    selectedType === 'Corporation DBA' ||
    selectedType === 'Partnership'
  ) {
    return [
      ...(docIds.corpResolution
        ? [
            {
              DocType: 'Corporate Resolution',
              DocId: docIds.corpResolution,
            },
          ]
        : []),
      ...(docIds.certIncorp
        ? [
            {
              DocType: 'Certificate of Incorporation',
              DocId: docIds.certIncorp,
            },
          ]
        : []),
      ...(docIds.articleIncorp
        ? [
            {
              DocType: 'Articles of Incorporation',
              DocId: docIds.articleIncorp,
            },
          ]
        : []),
      ...(docIds.listOfOfficers
        ? [
            {
              DocType: 'List of Directors and Officers',
              DocId: docIds.listOfOfficers,
            },
          ]
        : []),
      ...(docIds.regCertificate
        ? [
            {
              DocType: 'Commercial Registration Certificate',
              DocId: docIds.regCertificate,
            },
          ]
        : []),
    ];
  }
};
const typeLLCCheck = (selectedType, docIds) => {
  if (selectedType === 'LLC') {
    return [
      ...(docIds.LlcResolution
        ? [
            {
              DocType: 'LLC Resolution',
              DocId: docIds.LlcResolution,
            },
          ]
        : []),
      ...(docIds.certOfOrg
        ? [
            {
              DocType: 'Certificate of Organization',
              DocId: docIds.certOfOrg,
            },
          ]
        : []),
      ...(docIds.opAgreement
        ? [
            {
              DocType: 'Operational Agreement',
              DocId: docIds.opAgreement,
            },
          ]
        : []),
      ...(docIds.listOfOfficers
        ? [
            {
              DocType: 'List of Directors and Officers',
              DocId: docIds.listOfOfficers,
            },
          ]
        : []),
      ...(docIds.regCertificate
        ? [
            {
              DocType: 'Commercial Registration Certificate',
              DocId: docIds.regCertificate,
            },
          ]
        : []),
    ];
  }
};
const typeTrustCheck = (selectedType, docIds) => {
  if (selectedType === 'Trust') {
    return [
      ...(docIds.deedOfTrust
        ? [
            {
              DocType: 'Deed of Trust',
              DocId: docIds.deedOfTrust,
            },
          ]
        : []),
      ...(docIds.certOfTrustReg
        ? [
            {
              DocType: 'Certification for Trust Registry',
              DocId: docIds.certOfTrustReg,
            },
          ]
        : []),
      ...(docIds.certOfIncumbency
        ? [
            {
              DocType: 'Certificate of Incumbency',
              DocId: docIds.certOfIncumbency,
            },
          ]
        : []),
      ...(docIds.regCertificate
        ? [
            {
              DocType: 'Commercial Registration Certificate',
              DocId: docIds.regCertificate,
            },
          ]
        : []),
    ];
  }
};

const returnBusinessDocs = (selectedType, docIds) => {
  if (selectedType === 'DBA') {
    return typeDBACheck(selectedType, docIds);
  }
  if (
    selectedType === 'Corporation' ||
    selectedType === 'Corporation DBA' ||
    selectedType === 'Partnership'
  ) {
    return typeCorporationPartnership(selectedType, docIds);
  }
  if (selectedType === 'LLC') {
    return typeLLCCheck(selectedType, docIds);
  }
  if (selectedType === 'Trust') {
    return typeTrustCheck(selectedType, docIds);
  }
};

export const uploadLaterDocument = async (appId, accessToken) => {
  let response = null;
  try {
    response = await axios.post(
      process.env.REACT_APP_LINK_INITIAL_CALL,
      { applicationId: appId, docReUpload: 'true' },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
        },
      }
    );
  } catch (e) {
    return response;
  }
  return response;
};

export const saveDocChecklistUploadLater = async (
  docIds,
  context,
  docBusinessType,
  reUploadFlag,
  productName
) => {
  const { accessToken, language, location, urlAppId, parentUploadData, grandParentUploadData } =
    context;
  const currentUrl = window.location.href;
  let formData;

  if (currentUrl.includes('retail-form')) {
    formData = {
      Event: 'CaptureCaeDocuments',
      Application: {
        ApplicationID: urlAppId || null,
        TemplateVersion: '2021-08-05',
        Source: {
          Language: language,
          Location: 'PR',
          UtmSource: null,
          UtmMedium: null,
          UtmCampaign: null,
          UtmContent: null,
          UtmTerm: null,
          BranchCode: null,
        },
        Products: [
          {
            ProductType: 'IRA',
            ProductName: productName,
          },
        ],
        Beneficiaries: [
          {
            Documents: [
              ...(parentUploadData?.parent
                ? [{ DocType: 'CAE Form', DocId: parentUploadData.parent }]
                : []),
              ...(grandParentUploadData?.grandParent
                ? [
                    {
                      DocType: 'Proof of guardianship',
                      DocId: grandParentUploadData.grandParent,
                    },
                  ]
                : []),
            ],
          },
        ],
        Processing: {
          CaseReference: [],
        },
      },
    };
  } else {
    formData = {
      Event: 'CaptureDocumentReUpload',
      Application: {
        ApplicationID: urlAppId || null,
        TemplateVersion: '2021-11-24',
        Source: {
          Language: language,
          Location: location === 'VI' ? 'VI' : 'PR',
          UtmSource: null,
          UtmMedium: null,
          UtmCampaign: null,
          UtmContent: null,
          UtmTerm: null,
          BranchCode: null,
        },
        Business: {
          Type: docBusinessType,
          DocReUploadFlag: reUploadFlag,
          ...(returnBusinessDocs(docBusinessType, docIds).length > 0
            ? { BusinessDocuments: returnBusinessDocs(docBusinessType, docIds) }
            : {}),
        },
        Processing: {
          CaseReference: [],
        },
      },
    };
  }

  try {
    const result = await axios.post(process.env.REACT_APP_SAVE_SUBMIT_APPLICATION_URL, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        appid: SALES,
        'Content-Type': 'application/json; charset=UTF-8',
      },
    });
    return result;
  } catch (error) {
    return error.response;
  }
};

export const generateFileMD5 = (file) =>
  new Promise((resolve, reject) => {
    const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
    const chunkSize = 2097152;
    const chunks = Math.ceil(file.size / chunkSize);

    let currentChunk = 0;
    const spark = new SparkMD5.ArrayBuffer();
    const fileReader = new FileReader();

    fileReader.onload = (e) => {
      spark.append(e.target.result);
      currentChunk += 1;

      if (currentChunk < chunks) {
        loadNext();
      } else {
        const hash = spark.end();
        resolve(hash);
      }
    };

    fileReader.onerror = () => {
      reject();
    };
    function loadNext() {
      const start = currentChunk * chunkSize;
      const end = start + chunkSize >= file.size ? file.size : start + chunkSize;
      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
    }
    loadNext();
  });
